const http = () => window.axios;
const path = accountId => `/api/v1/accounts/${accountId}/open_api_token`;

export const fetchOpenApiToken = async accountId => {
  const { data } = await http().get(path(accountId));
  return data.payload;
};

export const issueOpenApiToken = async accountId => {
  const { data } = await http().post(path(accountId));
  return data.payload;
};
